import { AssignmentOutlined } from '@mui/icons-material';
import { Button, Grid, Typography } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useUser } from '../../../Hooks/useUser';
import { useGetJobPostingsQuery } from '../../../Redux/api/jobApi';
import { setShowUnverifiedModal } from '../../../Redux/slices/GlobalModalSlice';
import { useAppDispatch } from '../../../Redux/store';
import { IJobPosting } from '../../../Types/Job';
import { JobView } from './JobView';

interface IJobPostings {
    title: string;
    jobs: IJobPosting[];
}

export const ViewPosting = () => {
    /* ******************** Hooks ******************** */
    const navigate = useNavigate();
    const dispatch = useAppDispatch();
    const { isVerified } = useUser();
    const {
        data: postings, 
        isLoading: postingsLoading, 
        isFetching: postingsFetching,
    } = useGetJobPostingsQuery(undefined, {
        refetchOnMountOrArgChange: true
    })
    /* ******************** Variables ******************** */
    /* ******************** Functions ******************** */
    const handlePostJobClicked = () => {
        if (isVerified) {
            navigate('/post-creation');
            // dispatch(setJobPostingModalOpen(true));
            return
        }
        dispatch(setShowUnverifiedModal(true));
    }

    const formatPostings = () =>{
        const activeJobs: IJobPostings[] = [
            {title: 'Short-term job postings', jobs: postings?.ShortTerm ?? []},
            {title: 'Part-time job postings', jobs: postings?.PartTime ?? []},
            {title: 'Full-time job postings', jobs: postings?.FullTime ?? []},
            {title: 'Internship job postings', jobs: postings?.Internship ?? []},
            {title: 'Drafts', jobs: postings?.Drafts ?? []},
            // {title: 'Previous job postings', jobs: []},
        ]
        return activeJobs;
    }
    /* ******************** Effects ******************** */
    /* ******************** JSX ******************** */
    return (
        <>
            <Grid display={'flex'} flexDirection={'column'} gap={'60px'} marginBottom={4}>
                {
                    formatPostings().map((section, idx) => (
                        <Grid  display={'flex'} flexDirection={'column'} >
                            <Grid display={'flex'} flexDirection={'row'}>
                                <Grid flex={1}>
                                    <Typography variant='lora-headline-small' color={'primary.main'} marginBottom={'28px'}>{section.title}</Typography> 
                                </Grid>
                                {
                                    idx == 0 &&
                                    <Grid flex={1} display={'flex'} justifyContent={'flex-end'}>
                                        <Button variant='contained' onClick={handlePostJobClicked} >Post a job</Button>
                                    </Grid>
                                }
                            </Grid>
                            <Grid display={'flex'} flexDirection={'column'} marginTop={2}>
                                {
                                    section.jobs.length > 0 ?
                                    section.jobs.map( (j) => (  
                                        <JobView job={j} key={j.locator}/>
                                    )) :
                                    <Grid display={'flex'} xs flexDirection={'row'} justifyContent={'center'} >
                                        <Grid display={'flex'} flexDirection={'row'} gap={1}>
                                            <AssignmentOutlined sx={{fontSize: '24px', color: 'green.200'}}/>
                                            <Typography>No {section.title}</Typography>
                                        </Grid>
                                    </Grid>
                                }
                            </Grid>
                        </ Grid>
                    ))
                }                
            </Grid>   
        </>
    )
}
